import { HrCommonAuthority } from './hr-common-authority';
import { combineAuth } from './hr-authority';

export class PayrollAuthority extends HrCommonAuthority {

    public static readonly PAYROLL_BASE = "payroll";

    constructor(authority: string) {
        super(combineAuth(PayrollAuthority.PAYROLL_BASE, authority));
    }

}
